import MyTeamComponents from "features/myTeam/components/MyTeam";
import useMyTeam from "../hooks/useMyTeam";

function MyTeam() {
  const useMyTeamProps = useMyTeam();
  return <MyTeamComponents {...useMyTeamProps} />;
}

export default MyTeam;
